<h2 mat-dialog-title>
    <span>Fazer Upload</span>
</h2>
<div mat-dialog-content>
    <div class="upload-section">
        <button class="upload-section__button" (click)="removeImage()" type="button">
            <i class="fas fa-trash"></i>
        </button>
        <img [src]="imagePath ? imageUri : 'assets/image-placeholder.png'" class="upload-section__image" alt="">
    </div>
    <div class="input">
        <button type="button" mat-button (click)="fileInput.click()">Escolher arquivo</button>
        <input hidden (change)="onFileSelected($event)" #fileInput type="file" id="imagem" accept="image/*">
    </div>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="dismiss(false)">Cancelar</button>
    <button mat-stroked-button (click)="dismiss(true)">OK</button>
</div>